import { FormDiversAnnulationExtractorService } from './../divers/annulation/formdiversannulation-extractor.service';
import { FormDiversInitalExtractorService } from './../divers/diversInitial/services/form-divers-inital-extractor.service';
import {Injectable} from '@angular/core';
import {FormsEnum} from '../../../models/enums/forms.enum';
import {FormDiversAttributionExtractorService} from '../divers/diversAttribution/services/form-divers-attribution-extractor.service';
import {FormmapaANExtractorService} from '../mapa/annulation/formmapa-annulation.extractor.service';
import {FormfnsExtractorService} from '../fnsimple/initial/fnsimpleinitial-extractor.service';
import {FormmapaInitialExtractorService} from '../mapa/mapa-initial/formMapaInitial-extractor.service';
import {FormFnSimpleAnnulationExtractorService} from '../fnsimple/annulation/fnsimpleannulation-extractor.service';
import {FormmapaRecExtractorService} from '../mapa/rectificatif/services/formmapa-rectificatif-extractor.service';
import {FormmapaATExtractorService} from '../mapa/attribution/formmapa-attribution.extractor-service';
import {FormADExtractorService} from '../adapte/services/formad-extractor.service';
import {FormfnsAttributionExtractorService} from '../fnsimple/attribution/formfnsAttribution-extractor.service';
import {FormfnSimpleRectificatifExtractorService} from '../fnsimple/rectificatif/services/fnsimplerectificatif-extractor.service';
import {EformsExtractorService} from '../eforms/services/eforms-extractor.service';
import { FormDiversRectificatifExtractorService } from '../divers/rectificatif/formdiversrectificatif-extractor.service';

@Injectable({
  providedIn: 'root',
})
export class FormulaireExtractorDispatcherService {

	constructor(
		private formDiversAttributionExtractorService: FormDiversAttributionExtractorService,
		private formDiversInitalExtractorService: FormDiversInitalExtractorService,
		private formDiversAnnulationExtractorService: FormDiversAnnulationExtractorService,
		private formDiversRectificatifExtractorService: FormDiversRectificatifExtractorService,
		private formmapaInitialExtractorService: FormmapaInitialExtractorService,
		private formmapaANExtractorService: FormmapaANExtractorService,
		private formmapaRecExtractorService: FormmapaRecExtractorService,
		private formmapaATExtractorService: FormmapaATExtractorService,
		private formfnSimpleInitial: FormfnsExtractorService,
		private formfnSimpleAnnulation: FormFnSimpleAnnulationExtractorService,
		private formfnSimpleRectificatif: FormfnSimpleRectificatifExtractorService,
		private formfnSimpleAttribution: FormfnsAttributionExtractorService,
		private formADExtractorService: FormADExtractorService,
    private eformsExtractorService: EformsExtractorService
	) { }

  getExtractor(form: FormsEnum): any {
    const strform = form.toString();
    if (strform.includes('E_FORM')) {
      return this.eformsExtractorService;
    }
    switch (strform) {
			case 'DIVE_AT':
				return this.formDiversAttributionExtractorService;
			case 'MAPA_AN':
				return this.formmapaANExtractorService;
			case 'MAPA_IN':
				return this.formmapaInitialExtractorService;
			case 'MAPA_AT':
				return this.formmapaATExtractorService;
			case 'MAPA_RE':
				return this.formmapaRecExtractorService;
			case 'SIMP_IN':
				return this.formfnSimpleInitial;
			case 'SIMP_AN':
				return this.formfnSimpleAnnulation;
			case 'SIMP_RE':
				return this.formfnSimpleRectificatif;
			case 'SIMP_AT':
				return this.formfnSimpleAttribution;
			case 'FORM_AD':
				return this.formADExtractorService;
			case 'DIVE_IN':
				return this.formDiversInitalExtractorService;
			case 'DIVE_AN':
				return this.formDiversAnnulationExtractorService;
			case 'DIVE_RE':
				return this.formDiversRectificatifExtractorService;
			default:
        break;
    }
  }

  categorize(str: string) {
    if (str.includes('SIMP')) {
      return 'FNSimple';
    }
    if (str.includes('MAPA')) {
      return 'MAPA';
    }
    if (str.includes('DIVE')) {
      return 'DIVERS';
    }
  }
}
